import { useCallback, useState } from 'react';



const useToggle = (initState = false): [boolean, () => void] => {
  const [ isActive, setIsActive ] = useState<boolean>(initState);

  const toggle = useCallback(() => {
    setIsActive((prevState) => !prevState);
  }, []);

  return [ isActive, toggle ];
};

export default useToggle;
